/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DTypeRepository, DTypeToGoLiveRequest } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { format } from 'date-fns';
import { catchError, map, Subject, takeUntil, throwError } from 'rxjs';
import { DialogsService } from '../dialogs.service';
import { DTypeService } from '../../core/dtype/dtype.service';
import { LocalizePipe } from '../../core/pipes/localize.pipe';

@Component({
    selector: 'select-goal-date-dialog',
    templateUrl: './select-goal-date-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectGoalDateComponent implements OnInit, OnDestroy {

    date: FormControl = new FormControl<string>(undefined);
    datemin: string;

    private unsubscribe = new Subject<void>();

    constructor(
        public matDialogRef: MatDialogRef<SelectGoalDateComponent>,
        private dtypeService: DTypeService,
        private transloco: TranslocoService,
        private dialogsService: DialogsService,
        private localize: LocalizePipe
    ) { }

    ngOnInit() {
        const todayDate = new Date();
        this.datemin = format(todayDate, 'yyyy-MM-dd');
        this.date.setValue(todayDate);

        this.date.addValidators(Validators.required);
        this.date.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((value) => {
            this.dateControlChanged(value);
        });
    }

    ngOnDestroy() {
        this.unsubscribe.complete();
    }

    closeDialog(result?: DTypeRepository): void {
        this.matDialogRef.close(result);
    }

    openDatepickerOnClick(datepicker: MatDateRangePicker<Date>) {
        if (!datepicker.opened) {
            datepicker.open();
        }
    }

    save() {
        if (this.date.valid) {
            this.closeDialog(this.date.value);
        }
    }

    private dateControlChanged(value: Date | string) {
        if (value instanceof Date) {
            this.date.setValue(format(value, 'yyyy-MM-dd'), { emitEvent: false });
        }
    }
}
